import { FLIGHT_DEALS_ONLY } from "@/lib/release";
import { useEffect } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Bookmark, Camera, Map, Compass, Home, List, LogOut, Mountain, Plane, UserRound } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import "@/styles/traveller.css";
import ParticipantProfileMenu from "@/components/participant/ParticipantProfileMenu";

const links = [
  { to: "/traveller", label: "Home", icon: Home, end: true },
  { to: "/discover", label: "Explore", icon: Compass },
  { to: "/traveller/trips", label: "My trips", icon: Mountain },
  { to: "/traveller/wishlist", label: "Saved", icon: Bookmark },
  { to: "/traveller/memories", label: "Memories", icon: Camera, desktopOnly: true },
  { to: "/traveller/memory-map", label: "Memory Map", icon: Map },
  { to: "/traveller/profile", label: "Profile", icon: UserRound },
];

export default function TravellerLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);
  // Full traveller navigation stays intact for the future release.
  if (FLIGHT_DEALS_ONLY) return (
    <div className="traveller-app flight-launch-app">
      <header className="traveller-header">
        <Link to="/flight-deals" className="traveller-brand"><Mountain size={26} /><span>TrailPulse</span></Link>
        <nav aria-label="Traveller navigation" className="traveller-nav">
          <NavLink to="/flight-deals" aria-label="Flight deals" title="Flight deals" className={({ isActive }) => isActive ? "is-active" : ""}><Plane size={24} /><span>Flight deals</span></NavLink>
          <NavLink to="/prefetched-deals" aria-label="Prefetched deals" title="Prefetched deals" className={({ isActive }) => isActive ? "is-active" : ""}><List size={24} /><span>Prefetched deals</span></NavLink>
        </nav>
      </header>
      <div className="flight-launch-toolbar">
        <ParticipantProfileMenu links={[]} />
      </div>
      <main className="traveller-main">{children}</main>
      <footer className="traveller-footer"><span>TrailPulse</span><span>Support: <a href="mailto:hello@trailpulse.in" className="underline underline-offset-4">hello@trailpulse.in</a></span></footer>
    </div>
  );
  return (
    <div className="traveller-app">
      <header className="traveller-header">
        <Link to="/traveller" className="traveller-brand"><Mountain size={26} /><span>TrailPulse</span></Link>
        <nav aria-label="Traveller navigation" className="traveller-nav">
          {links.map(({ to, label, icon: Icon, end, desktopOnly }) => <NavLink key={to} to={to} end={end} title={label} aria-label={label} className={({ isActive }) => [isActive && "is-active", desktopOnly && "traveller-desktop-only"].filter(Boolean).join(" ")}><Icon size={24} strokeWidth={1.7} /><span>{label}</span></NavLink>)}
        </nav>
        <div className="traveller-account">
          <Link to="/flight-deals" title="Flight deals" aria-label="Flight deals"><Plane size={23} strokeWidth={1.7} /><span>Flight deals</span></Link>
          <button title="Sign out" aria-label="Sign out" onClick={async () => { await logout(); navigate("/login"); }}><LogOut size={23} strokeWidth={1.7} /><span>Sign out</span></button>
          <Link to="/traveller/profile" className="traveller-account-person" title="My profile"><span className="traveller-avatar">{(user?.full_name || "T").slice(0, 1).toUpperCase()}</span><span>{user?.full_name || "Traveller"}</span></Link>
          <ParticipantProfileMenu />
        </div>
      </header>
      <main className="traveller-main">{children}</main>
      <footer className="traveller-footer"><span>TrailPulse</span><Link to="/feedback">Feedback</Link></footer>
    </div>
  );
}
